import { ForgotPasswordContainer } from "@/components/organisms/ForgotPasswordContainer";

/**
 * Forgot Password Page
 * Handles the password reset flow
 */
export function ForgotPasswordPage() {
  return <ForgotPasswordContainer />;
}
